import { api } from "@shared/lib/api";
import {
  ACCOUNT_STATUS,
  BackednResponse,
  BrandType,
  GetBrands,
  IBrand,
  ICreateBrandUser,
  IEditBrandUser,
} from "@shared/lib/types";
import { CreateBrandRequest } from "../types";

export class BrandService {
  public static async getBrands(
    limit: number,
    pageNo: number,
    searchQuery?: string,
    status?: ACCOUNT_STATUS[],
    type?: BrandType[],
    permissionedUserBrandIds?: string[],
    companyName?: string[],
  ) {
    const params = new URLSearchParams();

    if (searchQuery) {
      params.append("searchQuery", searchQuery);
    }
    if (limit) {
      params.append("limit", limit.toString());
    }
    if (pageNo) {
      params.append("pageNo", pageNo.toString());
    }

    if (permissionedUserBrandIds && permissionedUserBrandIds?.length) {
      params.append(
        "permissionedUserBrandIds",
        permissionedUserBrandIds.join("$$"),
      ); //permissionedUserIds.join("$$"));
    }

    if (status && status?.length) {
      params.append("status", status.join("$$"));
    }
    if (type && type?.length) {
      params.append("type", type.join("$$"));
    }
    if (companyName && companyName?.length) {
      params.append("companyName", companyName.join("$$"));
    }

    // Convert params to string and add to URL only if there are parameters
    const queryString = params.toString();
    const url = `brand/${queryString ? `?${queryString}` : ""}`;
    const brands = (await api.get(url).json()) as BackednResponse<GetBrands>;

    return brands;
  }

  public static async createBrand(brand: CreateBrandRequest) {
    await api.post("brand", {
      json: {
        ...brand,
      },
    });
  }

  public static async updateBrand(brand: Partial<IBrand>, brandId: string) {
    return await api
      .patch(`brand`, {
        json: {
          ...brand,
          brandId,
        },
      })
      .json();
  }
  public static async editPermission(
    brandId: string,
    userId: string,
    permissions: string[],
  ) {
    return await api
      .patch(`brand/edit-permission`, {
        json: {
          brandId,
          userId,
          permissions,
        },
      })
      .json();
  }
  public static async deleteUser(brandId: string, userId: string) {
    return await api
      .delete(`brand/delete-permission`, {
        json: {
          brandId,
          userId,
        },
      })
      .json();
  }

  public static async getBrandPermissionsConst() {
    const url = `permissions/brand`;
    const brandPermissionsConst = (await api
      .get(url)
      .json()) as BackednResponse<string[]>;
    return brandPermissionsConst;
  }
  public static updateUserPermissions(
    brandId: string,
    userId: string,
    permissions: string[],
  ) {
    return api
      .patch(`brand/permission`, {
        json: {
          brandId,
          userId,
          permissions,
        },
      })
      .json();
  }
  public static deleteUserPermissions(brandId: string, userId: string) {
    return api
      .delete(`brand/permission`, {
        json: {
          brandId,
          userId,
        },
      })
      .json();
  }

  public static async getBrandById(id: string) {
    const url = `brand/${id}`;
    const brand = (await api.get(url).json()) as BackednResponse<IBrand>;
    return brand;
  }
  public static async getBrandRoles() {
    const url = `user/brand/roles`;

    const users = (await api.get(url).json()) as BackednResponse<{
      [key: string]: number;
    }>;

    return users;
  }

  public static async createBrandUser(brandId: string, data: ICreateBrandUser) {
    await api.post("user/brand", {
      json: {
        ...data,
        brandId,
      },
    });
  }
  public static async updateBrandUser(
    brandUserId: string,
    data: Partial<IEditBrandUser>,
  ) {
    await api.patch("user/brand", {
      json: {
        ...data,
        brandUserId,
      },
    });
  }
}
